
// src/pages/Auth/ResetPassword.js
import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link, useParams, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isTokenValid, setIsTokenValid] = useState(true);
    const [success, setSuccess] = useState(false);
    const [errors, setErrors] = useState({});

    // Kontrola platnosti tokenu
    useEffect(() => {
        const verifyToken = async () => {
            try {
                // Zde by byl API call pro ověření tokenu
                await new Promise(resolve => setTimeout(resolve, 500)); // Simulace API volání
                // Pokud by token byl neplatný, nastavili bychom setIsTokenValid(false)
            } catch (err) {
                setIsTokenValid(false);
            }
        };

        verifyToken();
    }, [token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const newErrors = {};
        if (formData.password.length < 8) {
            newErrors.password = 'Heslo musí mít alespoň 8 znaků';
        }

        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Hesla se neshodují';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsSubmitting(true);

        try {
            // Zde by byl API call pro reset hesla
            await new Promise(resolve => setTimeout(resolve, 1000)); // Simulace API volání
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setErrors({ form: 'Nepodařilo se resetovat heslo. Zkuste to prosím znovu.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isTokenValid) {
        return (
            <div className="auth-page">
                <div className="auth-card">
                    <div className="auth-header">
                        <div className="auth-logo">
                            <div className="avatar-circle mx-auto bg-danger">
                                <i className="fas fa-exclamation-triangle"></i>
                            </div>
                        </div>
                        <h1>Neplatný odkaz</h1>
                        <p className="text-muted">Odkaz pro reset hesla je neplatný nebo vypršel.</p>
                    </div>
                    <div className="auth-body text-center">
                        <p>Požádejte prosím o nový odkaz pro reset hesla.</p>
                        <Button as={Link} to="/forgot-password" variant="primary">
                            Nový reset hesla
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-header">
                    <div className="auth-logo">
                        <div className="avatar-circle mx-auto">
                            <i className="fas fa-key"></i>
                        </div>
                    </div>
                    <h1>Reset hesla</h1>
                    <p className="text-muted">Zadejte své nové heslo</p>
                </div>
                <div className="auth-body">
                    {success ? (
                        <Alert variant="success">
                            <i className="fas fa-check-circle me-2"></i>
                            Vaše heslo bylo úspěšně změněno! Budete přesměrováni na přihlašovací stránku...
                        </Alert>
                    ) : (
                        <Form onSubmit={handleSubmit}>
                            {errors.form && <Alert variant="danger">{errors.form}</Alert>}

                            <Form.Group className="mb-3">
                                <Form.Label>Nové heslo</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    isInvalid={!!errors.password}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                                <Form.Text className="text-muted">
                                    Heslo musí mít alespoň 8 znaků.
                                </Form.Text>
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label>Potvrzení hesla</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    isInvalid={!!errors.confirmPassword}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.confirmPassword}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <div className="d-grid mb-3">
                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                            Ukládání...
                                        </>
                                    ) : 'Uložit nové heslo'}
                                </Button>
                            </div>
                        </Form>
                    )}

                    <div className="text-center">
                        <Link to="/login" className="text-decoration-none">
                            <i className="fas fa-arrow-left me-2"></i> Zpět na přihlášení
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;